<template>
  <div>
    <transition name="slide-fade">
      <div class="edit-page" v-show="web == 'edit' || web == 'add' || web == 'detail'">
        <div class="title">
          <span v-show="web === 'add'">新增</span>
          <span v-show="web === 'edit'">编辑</span>
          <span v-show="web === 'detail'">详细</span>
        </div>
        <div class="el-form" label-position="top">
          <el-form ref="addForm" :model="addForm" label-width="100px" :rules="rules" :disabled="web == 'detail'">
            <el-row>
              <el-col :xs="24" :sm="14">
                <el-form-item label="公司名称:" prop="name">
                  <el-input v-model="addForm.name" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item class="form-item-phone-inline" label="客户联系人" prop="contact">
                  <el-button type="success" size="small" @click="addContact">新增客户联系人</el-button>
                  <el-button v-show="addForm.id" type="success" size="small" @click="addPay">收款登记</el-button>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-table :data="contacts" style="width: 100%">
                  <el-table-column label="客户联系人">
                    <template slot-scope="scope">
                      <el-input v-show="scope.row.state === 'add'" v-model="scope.row.name" placeholder="请输入">
                      </el-input>
                      <span v-show="scope.row.state !== 'add'">{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="联系方式">
                    <template slot-scope="scope">
                      <el-input v-show="scope.row.state === 'add'" v-model="scope.row.phone" placeholder="请输入">
                      </el-input>
                      <span v-show="scope.row.state !== 'add'">{{ scope.row.phone }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                      <el-button
                        v-show="scope.row.state === 'add'"
                        size="mini"
                        plain
                        type="success"
                        @click="contactFormSave(scope.$index, scope.row)"
                        >保存
                      </el-button>
                      <el-button size="mini" plain type="danger" @click="delContact(scope.$index, scope.row)"
                        >删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <!-- <el-col :xs="24" :sm="10">
                <el-form-item label="公司简称:" prop="simpleName">
                  <el-input v-model="addForm.simpleName" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :xs="24" :sm="24">
                <el-form-item class="show-pc roleName" label="区域:" prop="qy">
                  <el-cascader
                    class="width-100"
                    v-model="addForm.qy"
                    placeholder="请选择区域"
                    :options="options"
                    filterable
                    @change="qyChange"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item v-show="web !== 'detail'" class="show-phone roleName" label="区域:">
                  <div @click="popupShow">
                    <el-input v-model="addForm.qy2" :disabled="true"></el-input>
                  </div>
                </el-form-item>
                <el-form-item v-show="web == 'detail'" class="show-phone roleName" label="区域:">
                  <div>
                    <el-input v-model="addForm.qy2" :disabled="true"></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="地址:" prop="address">
                  <el-input v-model="addForm.address" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="法人" prop="legalPerson">
                  <el-input v-model="addForm.legalPerson" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="纳税性质" prop="taxNature">
                  <el-select v-model="addForm.taxNature" placeholder="请选择">
                    <el-option :label="item.name" :value="item.name" v-for="(item, index) in taxs" :key="'5-' + index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :xs="24" :sm="8">
                <el-form-item label="计费周期" prop="payType">
                  <el-select v-model="addForm.payType" placeholder="请选择" @change="payTypeChange">
                    <el-option :label="item.name" :value="item.name" v-for="(item, index) in cycle" :key="'6-' + index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item class="show-pc" label="计费时间" prop="payTime">
                  <el-date-picker
                    v-model="addForm.payTime"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="payTimeChange"
                  ></el-date-picker>
                  <el-button v-if="addForm.id" type="primary" size="small" @click="updatePayTime">
                    更新至下一计费周期</el-button
                  >
                </el-form-item>
                <el-form-item v-show="web !== 'detail'" class="show-phone" label="开始日期:">
                  <div @click="popupShowState2 = true">
                    <el-input v-model="addForm.payPeriodStart" :disabled="true"></el-input>
                  </div>
                </el-form-item>
                <el-form-item v-show="web !== 'detail'" class="show-phone" label="结束日期:">
                  <div @click="popupShowState3 = true">
                    <el-input v-model="addForm.payPeriodEnd" :disabled="true"></el-input>
                  </div>
                </el-form-item>
                <el-form-item v-show="web == 'detail'" class="show-phone" label="开始日期:">
                  <div>
                    <el-input v-model="addForm.payPeriodStart" :disabled="true"></el-input>
                  </div>
                </el-form-item>
                <el-form-item v-show="web == 'detail'" class="show-phone" label="结束日期:">
                  <div>
                    <el-input v-model="addForm.payPeriodEnd" :disabled="true"></el-input>
                  </div>
                </el-form-item>
              </el-col> -->
              <el-col :xs="24" :sm="24">
                <el-form-item class="form-item-phone-inline" label="收费项目" prop="fee">
                  <el-button type="success" size="small" @click="addFees">新增收费项目</el-button>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-table class="show-pc" :data="fees" style="width: 100%" :span-method="spanMethod4">
                  <el-table-column label="收费项目">
                    <template slot-scope="scope">
                      <el-row v-show="scope.row.state === 'add'">
                        <el-col :xs="24" :sm="5">
                          <el-input v-model="scope.row.name" placeholder="请输入收费项目"> </el-input>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                          <el-input-number
                            v-model="scope.row.price"
                            :min="0"
                            :step="0.01"
                            step-strictly
                            placeholder="请输入金额"
                          ></el-input-number>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                          <el-select v-model="scope.row.payType" placeholder="请选择计费周期">
                            <el-option
                              :label="item.name"
                              :value="item.name"
                              v-for="(item, index) in cycle"
                              :key="'11-' + index"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="9">
                          <el-date-picker
                            v-model="scope.row.payTime"
                            type="daterange"
                            range-separator="至"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                          ></el-date-picker>
                        </el-col>
                      </el-row>
                      <el-row v-show="scope.row.state !== 'add'">
                        <el-col :span="6">{{ scope.row.name }}</el-col>
                        <el-col :span="6">{{ scope.row.price }}</el-col>
                        <el-col :span="6"> {{ scope.row.payType }} </el-col>
                        <el-col :span="6">
                          {{ scope.row.payPeriodStart && scope.row.payPeriodStart.substring(0, 10) }} -
                          {{ scope.row.payPeriodEnd && scope.row.payPeriodEnd.substring(0, 10) }}
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column label="金额"></el-table-column>
                  <el-table-column label="计费周期"></el-table-column>
                  <el-table-column label="计费时间" width="250px"></el-table-column>
                  <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                      <el-button
                        v-show="scope.row.state === 'add'"
                        size="mini"
                        plain
                        type="success"
                        @click="feeFormSave(scope.$index, scope.row)"
                        >保存
                      </el-button>
                      <br class="show-phone" />
                      <el-button size="mini" plain type="danger" @click="delFee(scope.$index, scope.row)"
                        >删除
                      </el-button>
                      <br />
                      <el-button
                        v-show="addForm.id"
                        type="primary"
                        size="small"
                        @click="updatePayTime(scope.$index, scope.row)"
                      >
                        更新至下一计费周期
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table class="show-phone" :data="fees" style="width: 100%">
                  <el-table-column label="收费项目">
                    <template slot-scope="scope">
                      <el-row v-show="scope.row.state === 'add'">
                        <el-col :xs="24" :sm="5">
                          <span>收费项目：</span>
                          <el-input v-model="scope.row.name" placeholder="请输入"> </el-input>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                          <span>金额：</span>
                          <el-input-number
                            v-model="scope.row.price"
                            :min="0"
                            :step="0.01"
                            step-strictly
                            placeholder="请输入金额"
                          ></el-input-number>
                        </el-col>
                        <el-col :xs="24" :sm="5">
                          <span>计费周期：</span>
                          <el-select v-model="scope.row.payType" placeholder="请选择计费周期">
                            <el-option
                              :label="item.name"
                              :value="item.name"
                              v-for="(item, index) in cycle"
                              :key="'11-' + index"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="9">
                          <div class="show-phone">
                            <span>开始日期：</span>
                            <el-date-picker
                              v-model="scope.row.payPeriodStart"
                              type="date"
                              range-separator="至"
                              value-format="yyyy-MM-dd"
                              placeholder="开始日期"
                              @change="feePeriodStartChange(scope.row.payPeriodStart, scope.$index, scope.row)"
                            ></el-date-picker>
                          </div>
                          <div class="show-phone">
                            <span>结束日期：</span>
                            <el-date-picker
                              v-model="scope.row.payPeriodEnd"
                              type="date"
                              range-separator="至"
                              value-format="yyyy-MM-dd"
                              placeholder="结束日期"
                              @change="feePeriodEndChange(scope.row.payPeriodEnd, scope.$index, scope.row)"
                            ></el-date-picker>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row v-show="scope.row.state !== 'add'">
                        <el-col :xs="24" :sm="6">收费项目：{{ scope.row.name }}</el-col>
                        <el-col :xs="24" :sm="6">金额：{{ scope.row.price }}</el-col>
                        <el-col :xs="24" :sm="6">计费周期：{{ scope.row.payType }} </el-col>
                        <el-col :xs="24" :sm="6">
                          计费时间：
                          <br class="show-phone" />
                          {{ scope.row.payPeriodStart && scope.row.payPeriodStart.substring(0, 10) }} -
                          {{ scope.row.payPeriodEnd && scope.row.payPeriodEnd.substring(0, 10) }}
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100px">
                    <template slot-scope="scope">
                      <el-button
                        v-show="scope.row.state === 'add'"
                        size="mini"
                        plain
                        type="success"
                        @click="feeFormSave(scope.$index, scope.row)"
                        >保存
                      </el-button>
                      <br class="show-phone" />
                      <el-button size="mini" plain type="danger" @click="delFee(scope.$index, scope.row)"
                        >删除
                      </el-button>
                      <br class="show-phone" />
                      <el-button
                        v-show="addForm.id"
                        type="primary"
                        size="small"
                        @click="updatePayTime(scope.$index, scope.row)"
                      >
                        更新至
                        <br class="show-phone" />
                        下一
                        <br class="show-phone" />
                        计费周期
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="客户经理" prop="accountManagerId">
                  <el-select
                    v-model="addForm.accountManagerId"
                    placeholder="请选择"
                    @change="accountManagerChange"
                    :disabled="userInfo.type === 1"
                  >
                    <el-option :label="item.name" :value="item.id" v-for="(item, index) in persons" :key="'7-' + index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="负责人" prop="accountant">
                  <el-select
                    ref="accountant"
                    class="width-100"
                    v-model="addForm.accountant"
                    multiple
                    placeholder="请选择"
                    :disabled="userInfo.type === 1"
                    @change="accountantChange"
                  >
                    <el-option :label="item.name" :value="item.id" v-for="(item, index) in persons" :key="'8-' + index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="备注" prop="remark">
                  <el-input type="textarea" v-model="addForm.remark"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" v-show="addForm.id">
                <el-form-item class="form-item-phone-inline" label="图片名称" prop="wj">
                  <el-input size="small" v-model="addForm.picName" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" v-show="addForm.id">
                <el-form-item class="form-item-phone-inline" label="" prop="tp">
                  <span class="img-box">
                    <!-- 选择图片预览 -->
                    <img :src="picJdcmp.src" />
                    <!-- 选择按钮 -->
                    <div
                      class="el-button el-button--success el-button--small"
                      :class="{ upload: !picJdcmp.src, mask: picJdcmp.src }"
                    >
                      <div class="text" v-show="picJdcmp.src">重新选择</div>
                      <div class="text" v-show="!picJdcmp.src">选择图片</div>
                      <input
                        type="file"
                        name="picJdcmp"
                        accept="image/*"
                        :class="{ 'upload-file': !picJdcmp.src, 'mask-file': picJdcmp.src }"
                        ref="picJdcmp"
                        @change="picRead"
                      />
                    </div>
                  </span>
                  <!-- <el-button type="success" size="small" @click="uploadPic">上传图片</el-button> -->
                  <!-- <el-button type="primary" size="small" @click="queryPic">图片列表</el-button> -->
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" v-show="addForm.id">
                <p class="text-primary">
                  <el-button type="primary" size="mini" @click="picSelectionDownload">批量下载</el-button>
                </p>
                <el-table :data="pics" style="width: 100%" @selection-change="picSelectionChange">
                  <el-table-column type="selection" width="50"> </el-table-column>
                  <el-table-column label="图片名称">
                    <template slot-scope="scope">
                      <span>{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="图片">
                    <template slot-scope="scope">
                      <span>
                        <el-image
                          style="width: 100px; height: auto"
                          :src="scope.row.url"
                          :preview-src-list="[scope.row.url]"
                        >
                        </el-image>
                        <div
                          v-show="scope.row.url"
                          class="text-primary"
                          @click="downloadIamge(scope.row.url, '图片-' + scope.row.name)"
                        >
                          图片下载
                        </div>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" plain type="danger" @click="delPic(scope.row)">删除 </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :xs="24" :sm="12" v-show="addForm.id">
                <el-form-item class="form-item-phone-inline" label="文件名称" prop="wj">
                  <el-input size="small" v-model="addForm.fileName" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" v-show="addForm.id">
                <el-form-item class="form-item-phone-inline" label="" prop="wj">
                  <span class="img-box">
                    <!-- 选择按钮 -->
                    <div class="el-button el-button--success el-button--small upload">
                      <div class="text" v-show="picJdcmp.src">重新选择</div>
                      <div class="text" v-show="!picJdcmp.src">选择文件</div>
                      <input
                        type="file"
                        name="picJdcmp2"
                        accept="*"
                        class="upload-file"
                        ref="picJdcmp2"
                        @change="fileRead"
                      />
                    </div>
                  </span>
                  <!-- <el-button type="success" size="small" @click="uploadFile">上传文件</el-button> -->
                  <!-- <el-button type="primary" size="small" @click="queryFile">文件列表</el-button> -->
                  <p class="text-primary" v-show="picJdcmp2.src">选择文件名称：{{ picJdcmp2.src }}</p>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" v-show="addForm.id">
                <el-table :data="files" style="width: 100%">
                  <el-table-column label="文件">
                    <template slot-scope="scope">
                      <span>{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="下载">
                    <template slot-scope="scope">
                      <span>
                        <a :href="scope.row.url" target="_blank" :download="scope.row.name">下载</a>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" plain type="danger" @click="delFile(scope.row)">删除 </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-form>
          <el-form label-width="100px">
            <el-form-item class="btn">
              <el-button type="primary" size="small" class="save" v-show="!addForm.id" @click="addSave('addForm')"
                >保存
              </el-button>
              <el-button
                type="primary"
                size="small"
                class="save"
                v-show="addForm.id && web != 'detail'"
                @click="editSave('addForm')"
                >保存
              </el-button>
              <el-button type="primary" size="small" plain class="cancel" @click="cancel">返回</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </transition>

    <van-popup v-model="popupShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="picker2"
        show-toolbar
        title="区域"
        :columns="options"
        cancel-button-text="清空"
        @confirm="pickerConfirm"
        @cancel="pickerCancel"
      />
    </van-popup>

    <van-popup v-model="popupShowState2" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="addForm.payPeriodStart2"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        cancel-button-text="清空"
        @confirm="pickerConfirm2"
        @cancel="pickerCancel2"
      />
    </van-popup>
    <van-popup v-model="popupShowState3" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="addForm.payPeriodEnd2"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        cancel-button-text="清空"
        @confirm="pickerConfirm3"
        @cancel="pickerCancel3"
      />
    </van-popup>
    <el-drawer size="300px" :with-header="false" :visible.sync="drawer">
      <div class="drawer-box">
        <el-form
          ref="payRecord"
          :label-position="'top'"
          :model="payRecord"
          label-width="100px"
          :rules="rules4"
          :disabled="web == 'detail'"
        >
          <div class="title" style="padding:8px">收款登记</div>
          <el-row>
            <el-col :xs="24" :sm="24">
              <el-form-item label="客户名称:" prop="customerName">
                <el-input :disabled="true" v-model="payRecord.customerName" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="收款项目" prop="payProject">
                <el-input v-model="payRecord.payProject" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="金额:" prop="amount">
                <el-input-number
                  v-model="payRecord.amount"
                  :min="0"
                  :step="0.01"
                  step-strictly
                  placeholder="请输入金额"
                ></el-input-number>
                <span slot="append">元</span>
                <!-- <el-input type="number" min="0" v-model="payRecord.amount" placeholder="请输入">
                <template slot="append">元</template>
              </el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="折扣:" prop="discount">
                <el-input-number
                  v-model="payRecord.discount"
                  :min="0.1"
                  :max="10"
                  :step="0.1"
                  step-strictly
                  placeholder="请输入金额"
                ></el-input-number>
                <span slot="append">折</span>
                <!-- <el-input type="number" min="0" max="9.99" v-model="payRecord.discount" placeholder="请输入">
                <template slot="append">折</template>
              </el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="实收金额:" prop="realAmount">
                <el-input-number
                  v-model="payRecord.realAmount"
                  :min="0"
                  :step="0.01"
                  step-strictly
                  placeholder="请输入金额"
                ></el-input-number>
                <span slot="append">元</span>
                <!-- <el-input type="number" min="0" v-model="payRecord.realAmount" placeholder="请输入">
                <template slot="append">元</template>
              </el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="尾款:" prop="finalPayment">
                <el-input-number
                  v-model="payRecord.finalPayment"
                  :min="0"
                  :step="0.01"
                  step-strictly
                  placeholder="请输入金额"
                ></el-input-number>
                <span slot="append">元</span>
                <!-- <el-input type="number" min="0" v-model="payRecord.finalPayment" placeholder="请输入">
                <template slot="append">元</template>
              </el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="收款经办人:">
                <el-input :value="userInfo.name" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item class="show-pc" label="合同时间" prop="payTime">
                <el-date-picker
                  v-model="payRecord.payTime"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="show-phone" label="开始日期:">
                <el-date-picker
                  v-model="payRecord.payPeriodStart"
                  type="date"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  @change="payPeriodStartChange"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="show-phone" label="结束日期:">
                <el-date-picker
                  v-model="payRecord.payPeriodEnd"
                  type="date"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  @change="payPeriodEndChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="备注:" prop="remark">
                <el-input type="textarea" v-model="payRecord.remark" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item>
                <el-button type="primary" size="small" class="save" @click="addPaySave('payRecord')">保存 </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>

    <el-dialog :visible.sync="dialogVisable" :append-to-body="true" width="320px">
      <div style="width:300px; margin: 0 auto">
        <div class="text-left">收费项目： {{ feeForm.name }}</div>
        <div class="text-left">金额： {{ feeForm.price }}</div>
        <div class="text-left">计费周期类型： {{ feeForm.payType }}</div>
        <div class="text-left">
          当前计费周期： {{ feeForm.payPeriodStart && feeForm.payPeriodStart.substring(0, 10) }} -
          {{ feeForm.payPeriodEnd && feeForm.payPeriodEnd.substring(0, 10) }}
        </div>
        <div class="text-left text-primary">下一计费周期： {{ payTimeStart }} - {{ payTimeEnd }}</div>
        <!-- <div>
          <el-table :data="fees" style="width: 100%">
            <el-table-column label="收费项目">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="金额">
              <template slot-scope="scope">
                <span>{{ scope.row.price }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div> -->
      </div>
      <div slot="footer" class="text-center dialog-footer">
        <el-button size="small" plain type="primary" @click="updatePayPeriod">确定更新 </el-button>
        <el-button type="primary" plain size="small" class="save" @click="drawer = false">返回 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cityData from '../../../utils/Data'
export default {
  name: 'Detail',
  props: {
    detailData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    detailPersons: {
      type: Array,
      default: () => {
        return []
      }
    },
    webState: {
      type: String,
      default: 'add'
    },
    customerId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    webState: {
      handler(newVal, oldVal) {
        console.log(newVal)
        this.web = newVal
      },
      immediate: true,
      deep: true
    },
    detailData: {
      handler(newVal, oldVal) {
        console.log(newVal)
        this.addForm = newVal
      },
      immediate: true,
      deep: true
    },
    customerId: {
      handler(newVal, oldVal) {
        console.log(newVal)
        if (this.addForm.id) {
          this.queryContact() // 查询客户联系人
          this.queryFee()
          this.queryAccountant()
        }
      },
      immediate: true,
      deep: true
    },
    detailPersons: {
      handler(newVal, oldVal) {
        console.log(newVal)
        this.persons = newVal
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      userInfo: {},
      titles: ['客户中心'],
      web: 'main',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      payTimeStart: '',
      payTimeEnd: '',
      addForm: {
        name: '', // 公司名称
        simpleName: '', // 公司简称
        qy: '', // 区域
        qy2: '', // 区域
        area1: '',
        area2: '',
        area3: '',
        address: '', // 地址
        legalPerson: '', // 法人
        lxr: '', // 联系人
        lxdh: '', // 联系电话
        taxNature: '', // 纳税性质
        payType: '', // 计费周期
        payType2: '', // 计费周期
        payTime: [], // 计费时间
        payPeriodStart: '',
        payPeriodEnd: '',
        payPeriodStart2: new Date(),
        payPeriodEnd2: new Date(),
        accountManagerId: '', // 客户经理
        accountManager: '',
        accountant: '', // 负责人
        remark: '', // 备注
        picJdcmp: '',
        picJdcmp2: ''
      },
      taxs: [
        { roleId: '小规模', roleName: '小规模' },
        { roleId: '一般纳税人', roleName: '一般纳税人' }
      ],
      persons: [],
      cycle: [
        { roleId: '30', roleName: '月付' },
        { roleId: '90', roleName: '季付' },
        { roleId: '180', roleName: '半年付' },
        { roleId: '360', roleName: '年付' }
      ],
      cycle2: [
        { roleId: '月付', roleName: '月付' },
        { roleId: '季付', roleName: '季付' },
        { roleId: '半年付', roleName: '半年付' },
        { roleId: '年付', roleName: '年付' }
      ],
      options: cityData,
      fees: [],
      feeForm: {
        name: '',
        price: ''
      }, // 收费项目数组
      contacts: [], // 客户联系人数组
      contactForm: {
        name: '',
        phone: ''
      }, // 客户联系人对象
      accountant: [], // 负责人数组
      picJdcmp: { src: '', file: '', name: '图片' },
      picJdcmp2: { src: '', file: '', name: '文件' },
      pics: [],
      files: [],
      popupShowState: false,
      popupShowState2: false,
      popupShowState3: false,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(2099, 0, 1),
      currentDate: new Date(),
      dialogVisable: false,
      picSelection: [],
      fileSelection: [],
      drawer: false,
      payRecord: {
        customerName: '', // 客户名称
        payProject: '', // 收费项目名称
        amount: '', // 总金额
        realAmount: '', // 实收金额
        discount: 10, // 折扣
        finalPayment: '', // 尾款
        payPeriodStart: '', // 计费周期始
        payPeriodEnd: '', // 计费周期止
        payTime: [],
        remark: ''
      },
      rules: {
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        // simpleName: [{ required: true, message: '请输入公司简称', trigger: 'blur' }],
        // qy: [{ required: true, message: '请选择区域', trigger: 'change' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        // legalPerson: [{ required: true, message: '请输入法人', trigger: 'blur' }],
        taxNature: [{ required: true, message: '请选择纳税性质', trigger: 'change' }],
        // payType: [{ required: true, message: '请选择计费周期', trigger: 'change' }],
        // payTime: [{ required: true, message: '请选择计费时间', trigger: 'change' }],
        accountManagerId: [{ required: true, message: '请选择客户经理', trigger: 'change' }]
        // accountant: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        // remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },
      rules2: {
        name: [{ required: true, message: '请输入客户联系人姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入客户联系人手机号', trigger: 'blur' }]
      },
      rules3: {
        name: [{ required: true, message: '请输入收费项目名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入收费金额', trigger: 'blur' }]
      },
      rules4: {
        customerName: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        payProject: [{ required: true, message: '请输入收费项目名称', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入总金额', trigger: 'blur' }],
        realAmount: [{ required: true, message: '请输入收费金额', trigger: 'blur' }],
        discount: [{ required: true, message: '请输入折扣', trigger: 'blur' }],
        finalPayment: [{ required: true, message: '请输入尾款', trigger: 'blur' }]
      }
    }
  },
  methods: {
    spanMethod4({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return [1, 4]
      } else if (columnIndex === 1) {
        return [0, 0]
      } else if (columnIndex === 2) {
        return [0, 0]
      } else if (columnIndex === 3) {
        return [0, 0]
      }
    },
    handleClose() {},
    // 详情信息初始化
    init() {
      if (this.addForm.id) {
        this.queryContact() // 查询客户联系人
        this.queryFee()
        this.queryAccountant()
        this.queryPic()
        this.queryFile()
      }
      if (this.userInfo.type === 1) {
        console.log('init:' + this.userInfo.type)
        setTimeout(() => {
          this.addForm.accountManagerId = this.userInfo.id
          this.accountManagerChange(this.userInfo.id)
          const accountants = []
          for (let i = 0; i < this.persons.length; i++) {
            if (this.persons[i].id === this.userInfo.id) {
              accountants.push({
                uid: this.persons[i].id,
                name: this.persons[i].name
              })
            }
          }
          this.accountants = accountants
        }, 100)
      }
      console.log(this.$refs.picker2)
      this.$refs.picker2.setValues(this.addForm.qy)
    },
    // 区域选择框展示
    popupShow() {
      this.popupShowState = true
    },
    // 计费周期修改
    payTypeChange(val) {
      let code = ''
      for (let i = 0; i < this.cycle.length; i++) {
        if (this.cycle[i].name === val) {
          code = this.cycle[i].code
        }
      }
      console.log(code)
      var d1 = this.addForm.payPeriodStart ? new Date(this.addForm.payPeriodStart) : new Date()
      var d2 = this.addForm.payPeriodStart ? new Date(this.addForm.payPeriodStart) : new Date()
      if (code === '1') {
        d2.setMonth(d2.getMonth() + 12)
        d2.setDate(d2.getDate() - 1)
      } else if (code === '2') {
        d2.setMonth(d2.getMonth() + 6)
        d2.setDate(d2.getDate() - 1)
      } else if (code === '3') {
        d2.setMonth(d2.getMonth() + 3)
        d2.setDate(d2.getDate() - 1)
      } else if (code === '4') {
        d2.setMonth(d2.getMonth() + 1)
        d2.setDate(d2.getDate() - 1)
      }
      console.log(d1, d2)
      this.addForm.payPeriodStart = this.$common.timeFormat(d1, 'yyyy-MM-dd')
      this.addForm.payPeriodEnd = this.$common.timeFormat(d2, 'yyyy-MM-dd')
      this.addForm.payTime = [this.addForm.payPeriodStart, this.addForm.payPeriodEnd]
      this.addForm.payPeriodStart2 = new Date(this.addForm.payPeriodStart)
      this.addForm.payPeriodEnd2 = new Date(this.addForm.payPeriodEnd)
    },
    // 计费时间
    payTimeChange(val) {
      console.log(val)
      if (val) {
        this.addForm.payPeriodStart = val[0]
        this.addForm.payPeriodEnd = val[1]
        this.addForm.payPeriodStart2 = new Date(this.addForm.payPeriodStart)
        this.addForm.payPeriodEnd2 = new Date(this.addForm.payPeriodEnd)
      } else {
        this.addForm.payPeriodStart = ''
        this.addForm.payPeriodEnd = ''
        this.addForm.payPeriodStart2 = ''
        this.addForm.payPeriodEnd2 = ''
      }
    },
    // 更新至下一收费周期点击
    updatePayTime(index, data) {
      this.feeId = data.id
      this.feeForm = data
      console.log(data.payPeriodStart, data.payPeriodEnd)
      console.log(this.addForm.payType)
      this.dialogVisable = true
      let code = ''
      for (let i = 0; i < this.cycle.length; i++) {
        if (this.cycle[i].name === data.payType) {
          code = this.cycle[i].code
        }
      }
      var d1 = new Date(data.payPeriodStart)
      var d2 = new Date(data.payPeriodEnd)
      if (code === '1') {
        d1.setMonth(d1.getMonth() + 12)
        d2.setMonth(d2.getMonth() + 12)
      } else if (code === '2') {
        d1.setMonth(d1.getMonth() + 6)
        d2.setMonth(d2.getMonth() + 6)
      } else if (code === '3') {
        d1.setMonth(d1.getMonth() + 3)
        d2.setMonth(d2.getMonth() + 3)
      } else if (code === '4') {
        d1.setMonth(d1.getMonth() + 1)
        d2.setMonth(d2.getMonth() + 1)
      }
      this.payTimeStart = this.$common.timeFormat(d1, 'yyyy-MM-dd')
      this.payTimeEnd = this.$common.timeFormat(d2, 'yyyy-MM-dd')
    },
    // 更新至下一收费周期
    updatePayPeriod() {
      const param = {
        id: this.feeId
      }
      this.$get('/customer/updatePayPeriod', param).then(
        result => {
          if (result.status === 200) {
            this.queryFee()
            this.dialogVisable = false
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 区域更改
    qyChange(val) {
      if (val) {
        this.addForm.area1 = val[0]
        this.addForm.area2 = val[1]
        this.addForm.area3 = val[2]
        this.addForm.qy2 = val.join('/')
        this.$refs.picker2.setValues(this.addForm.qy)
      }
    },
    // 区域选择确定
    pickerConfirm(val, indexs) {
      this.addForm.qy = val
      this.addForm.qy2 = val.join('/')
      this.addForm.area1 = val[0]
      this.addForm.area2 = val[1]
      this.addForm.area3 = val[2]
      this.popupShowState = false
    },
    // 区域选择
    pickerCancel(val, indexs) {
      this.addForm.qy = val
      this.addForm.qy2 = val.join('/')
      this.addForm.area1 = val[0]
      this.addForm.area2 = val[1]
      this.addForm.area3 = val[2]
      this.popupShowState = false
    },
    // 计费时间开始确定
    pickerConfirm2(val, indexs) {
      const time = this.$common.timeFormat(new Date(val), 'yyyy-MM-dd')
      console.log(val)
      this.addForm.payPeriodStart = time
      if (this.addForm.payPeriodStart && this.addForm.payPeriodEnd) {
        this.addForm.payTime = [this.addForm.payPeriodStart, this.addForm.payPeriodEnd]
      }
      this.popupShowState2 = false
    },
    // 计费时间开始取消
    pickerCancel2(val, indexs) {
      console.log(val)
      this.addForm.payPeriodStart = ''
      this.popupShowState2 = false
    },
    // 计费时间结束确定
    pickerConfirm3(val, indexs) {
      const time = this.$common.timeFormat(new Date(val), 'yyyy-MM-dd')
      console.log(val)
      this.addForm.payPeriodEnd = time
      if (this.addForm.payPeriodStart > this.addForm.payPeriodEnd) {
        this.$root.$children[0].vueAlert({ message: '结束时间不能小于开始时间', type: 'error' })
        return
      }
      if (this.addForm.payPeriodStart && this.addForm.payPeriodEnd) {
        this.addForm.payTime = [this.addForm.payPeriodStart, this.addForm.payPeriodEnd]
      }
      this.popupShowState3 = false
    },
    // 计费时间结束取消
    pickerCancel3(val, indexs) {
      console.log(val)
      this.addForm.payPeriodEnd = ''
      this.popupShowState3 = false
    },

    /**
      查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.cycle = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 获取所有员工
    queryUserIdName() {
      const param = {}
      this.$get('/user/queryUserIdName', param).then(
        result => {
          if (result.status === 200) {
            this.persons = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询收费项目
    queryFee() {
      const param = {
        customerId: this.addForm.id
      }
      this.$get('/customer/queryFee', param).then(
        result => {
          if (result.status === 200) {
            this.fees = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询负责人
    queryAccountant() {
      const param = {
        customerId: this.addForm.id
      }
      this.$get('/customer/queryAccountant', param).then(
        result => {
          if (result.status === 200) {
            this.accountants = result.data
            this.addForm.accountant = []
            for (let i = 0; i < this.accountants.length; i++) {
              this.addForm.accountant.push(this.accountants[i].uid)
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询图片
    queryPic() {
      const param = {
        oid: this.addForm.id
      }
      this.$get('/pic/query', param).then(
        result => {
          if (result.status === 200) {
            this.pics = result.data
            // this.web = 'pic'
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询文件
    queryFile() {
      const param = {
        oid: this.addForm.id
      }
      this.$get('/file/query', param).then(
        result => {
          if (result.status === 200) {
            this.files = result.data
            // this.web = 'file'
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 客户经理选择变化
    accountManagerChange(val) {
      for (let i = 0; i < this.persons.length; i++) {
        if (this.persons[i].id === val) {
          this.addForm.accountManager = this.persons[i].name
        }
      }
      console.log(this.addForm)
    },
    // 负责人选择变化
    accountantChange(val) {
      if (this.addForm.id) {
        console.log(val)
        if (val.length < this.accountants.length) {
          const ids = []
          for (let i = 0; i < this.accountants.length; i++) {
            ids.push(this.accountants[i].uid)
          }
          const arr = ids.filter(item => {
            return val.indexOf(item) < 0
          })
          this.delAccountant(arr[0])
          console.log(arr)
          return false // 删除操作
        } else {
          const ids = []
          for (let i = 0; i < this.accountants.length; i++) {
            ids.push(this.accountants[i].uid)
          }
          const arr = val.filter(item => {
            return ids.indexOf(item) < 0
          })
          let name = ''
          for (let i = 0; i < this.persons.length; i++) {
            if (this.persons[i].id === arr[0]) {
              name = this.persons[i].name
            }
          }
          const param = {
            customerId: this.addForm.id,
            name: name,
            uid: arr[0]
          }
          this.$get('/customer/addAccountant', param).then(
            result => {
              if (result.status === 200) {
                this.queryAccountant()
                this.$refs.accountant.blur()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
          console.log(arr)
        }
      } else {
        const accountants = []
        for (let i = 0; i < this.persons.length; i++) {
          for (let j = 0; j < val.length; j++) {
            if (this.persons[i].id === val[j]) {
              accountants.push({
                uid: this.persons[i].id,
                name: this.persons[i].name
              })
            }
          }
        }
        this.accountants = accountants
      }
      setTimeout(() => {
        this.$refs.accountant.blur()
      }, 50)
    },
    // 删除负责人
    delAccountant(val) {
      let id = ''
      for (let i = 0; i < this.accountants.length; i++) {
        if (val === this.accountants[i].uid) {
          id = this.accountants[i].id
        }
      }
      const param = {
        id: id
      }
      this.$get('/customer/deleteAccountant', param).then(
        result => {
          if (result.status === 200) {
            this.queryAccountant()
            this.$refs.accountant.blur()
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 新增收费
    addPay() {
      this.drawer = true
      this.payRecord = {
        caseId: '', // 案件id
        customerId: '', // 客户id
        customerName: this.addForm.name, // 客户名称
        payProject: '', // 收费项目名称
        amount: '', // 总金额
        realAmount: '', // 实收金额
        discount: 10, // 折扣
        finalPayment: '', // 尾款
        payPeriodStart: '', // 计费周期始
        payPeriodEnd: '', // 计费周期止
        payTime: [],
        remark: ''
      }
      this.$nextTick(() => {
        this.$refs.payRecord.clearValidate()
      })
    },
    payPeriodStartChange(val) {
      if (this.payRecord.payPeriodEnd && val > this.payRecord.payPeriodEnd) {
        this.payRecord.payPeriodStart = this.payRecord.payPeriodEnd
        return this.$message.error('请选择开始时间不能大于结束时间！')
      }
      console.log(val)
      if (val && this.payRecord.payPeriodEnd) {
        this.payRecord.payTime = [this.payRecord.payPeriodStart, this.payRecord.payPeriodEnd]
      }
    },
    payPeriodEndChange(val) {
      console.log(val)
      if (!this.payRecord.payPeriodStart) {
        this.payRecord.payPeriodEnd = ''
        return this.$message.error('请选择开始时间！')
      }
      if (val < this.payRecord.payPeriodStart) {
        this.payRecord.payPeriodEnd = this.payRecord.payPeriodStart
        return this.$message.error('结束时间不能小于开始时间！')
      }
      if (val && this.payRecord.payPeriodStart) {
        this.payRecord.payTime = [this.payRecord.payPeriodStart, this.payRecord.payPeriodEnd]
      }
    },
    addPaySave() {
      if (!this.payRecord.payTime[0]) {
        this.payRecord.payPeriodStart = ''
        this.payRecord.payPeriodEnd = ''
      } else {
        this.payRecord.payPeriodStart = this.$common.timeFormat(
          new Date(this.payRecord.payTime[0]),
          'yyyy-MM-dd 00:00:00'
        )
        this.payRecord.payPeriodEnd = this.$common.timeFormat(
          new Date(this.payRecord.payTime[1]),
          'yyyy-MM-dd 00:00:00'
        )
      }
      this.$refs.payRecord.validate(valid => {
        if (valid) {
          const param = {
            // caseId: this.addForm.id, // 案件id
            customerId: this.addForm.id, // 客户id
            customerName: this.payRecord.customerName, // 客户名称
            payProject: this.payRecord.payProject, // 收费项目名称
            amount: this.payRecord.amount, // 总金额
            realAmount: this.payRecord.realAmount, // 实收金额
            discount: this.payRecord.discount, // 折扣
            finalPayment: this.payRecord.finalPayment, // 尾款
            payPeriodStart: this.payRecord.payPeriodStart, // 计费周期始
            payPeriodEnd: this.payRecord.payPeriodEnd, // 计费周期止
            operName: this.userInfo.name,
            operId: this.userInfo.id,
            remark: this.payRecord.remark
          }
          this.$post('/financial/addPayRecord', param).then(
            result => {
              if (result.status === 200) {
                this.drawer = false
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log(valid)
        }
      })
    },
    // 新增收费项目
    addFees() {
      this.fees.push({
        state: 'add',
        customerName: this.addForm.name,
        name: '',
        price: '',
        payType: '',
        payPeriodStart: '',
        payPeriodEnd: '',
        payTime: []
      })
    },
    feePeriodStartChange(val, index, data) {
      if (data.payPeriodEnd && val > data.payPeriodEnd) {
        val = data.payPeriodEnd
        this.$message.error('请选择开始时间不能大于结束时间！')
      }
      console.log(val)
      if (val && data.payPeriodEnd) {
        data.payTime = [data.payPeriodStart, data.payPeriodEnd]
      }
    },
    feePeriodEndChange(val, index, data) {
      console.log(val)
      if (!data.payPeriodStart) {
        data.payPeriodEnd = ''
        this.$message.error('请选择开始时间！')
      }
      if (val < data.payPeriodStart) {
        data.payPeriodEnd = data.payPeriodStart
        this.$message.error('结束时间不能小于开始时间！')
      }
      if (val && data.payPeriodStart) {
        data.payTime = [data.payPeriodStart, data.payPeriodEnd]
      }
    },
    // 删除收费项目
    delFee(index, data) {
      if (data.id) {
        const param = {
          id: data.id
        }
        this.$root.$children[0].vueConfirm({ message: '确定要删除收费项目？', type: 'warning' }, () => {
          this.$get('/customer/deleteFee', param).then(
            result => {
              if (result.status === 200) {
                this.queryFee()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        })
      } else {
        this.fees.splice(index, 1)
      }
    },
    feeFormSave(index, data) {
      console.log(data)
      if (!data.name) {
        return this.$toast('请填写收费项目！')
      }
      if (!data.price) {
        return this.$toast('请填写金额！')
      }
      if (!data.payType) {
        return this.$toast('请选择计费周期！')
      }
      if (!data.payTime[0]) {
        return this.$toast('请选择计费时间！')
      } else {
        data.payPeriodStart = data.payTime[0]
        data.payPeriodEnd = data.payTime[1]
      }
      if (this.addForm.id) {
        const param = {
          customerId: this.addForm.id,
          customerName: this.addForm.name,
          name: data.name,
          price: data.price,
          payPeriodStart: this.$common.timeFormat(new Date(data.payPeriodStart), 'yyyy-MM-dd 00:00:00'),
          payPeriodEnd: this.$common.timeFormat(new Date(data.payPeriodEnd), 'yyyy-MM-dd 00:00:00'),
          payType: data.payType
        }
        this.$post('/customer/addFee', param).then(
          result => {
            if (result.status === 200) {
              this.fees[index].state = ''
              this.queryFee()
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      } else {
        this.fees[index].payPeriodStart = this.$common.timeFormat(
          new Date(this.fees[index].payTime[0]),
          'yyyy-MM-dd 00:00:00'
        )
        this.fees[index].payPeriodEnd = this.$common.timeFormat(
          new Date(this.fees[index].payTime[1]),
          'yyyy-MM-dd 00:00:00'
        )
        this.fees[index].state = ''
        console.log(this.fees)
      }
    },
    // 查询客户联系人
    queryContact() {
      const param = {
        id: this.addForm.id
      }
      this.$get('/customer/queryContact', param).then(
        result => {
          if (result.status === 200) {
            this.contacts = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 新增客户联系人点击
    addContact() {
      this.contacts.push({
        state: 'add',
        name: '',
        phone: ''
      })
    },
    // 客户联系人保存
    contactFormSave(index, data) {
      if (!data.name) {
        return this.$toast('请填写客户联系人！')
      }
      if (!data.phone) {
        return this.$toast('请填写联系电话！')
      }
      if (this.addForm.id) {
        const param = {
          customerId: this.addForm.id,
          name: data.name,
          phone: data.phone
        }
        this.$get('/customer/addContact', param).then(
          result => {
            if (result.status === 200) {
              this.contacts[index].state = ''
              this.queryContact()
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      } else {
        this.contacts[index].state = ''
      }
    },
    // 删除客户联系人
    delContact(index, data) {
      if (data.id) {
        const param = {
          id: data.id
        }
        this.$root.$children[0].vueConfirm({ message: '确定要删除客户联系人？', type: 'warning' }, () => {
          this.$get('/customer/deleteContact', param).then(
            result => {
              if (result.status === 200) {
                this.queryContact()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        })
      } else {
        this.contacts.splice(index, 1)
      }
    },
    // 图片预览
    picRead(e) {
      if (!this.addForm.picName) {
        this.$refs[e.target.name].value = ''
        return this.$root.$children[0].vueAlert({ message: '请填写图片名称', type: 'error' })
      }
      const _this = this
      var files = e.target.files[0]
      console.log(e)
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      const reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function() {
        _this[e.target.name] = {
          src: this.result,
          file: e.target.files[0]
        }
        _this.addForm[e.target.name] = e.target.files[0]
        _this.$refs[e.target.name].value = ''
        _this.uploadPic()
      }
    },
    // 图片预览
    fileRead(e) {
      if (!this.addForm.fileName) {
        this.$refs[e.target.name].value = ''
        return this.$root.$children[0].vueAlert({ message: '请填写文件名称', type: 'error' })
      }
      var files = e.target.files[0]
      console.log(files)
      console.log(files.name)
      console.log(e.target.name)
      this[e.target.name] = {
        src: files.name,
        file: e.target.files[0]
      }
      this.addForm[e.target.name] = e.target.files[0]
      this.$refs[e.target.name].value = ''
      this.uploadFile()
    },
    uploadFile() {
      const param = new FormData()
      if (!this.addForm.fileName) {
        return this.$root.$children[0].vueAlert({ message: '请填写文件名称', type: 'error' })
      }
      if (!this.addForm.picJdcmp2) {
        return this.$root.$children[0].vueAlert({ message: '请选择文件', type: 'error' })
      }
      param.append('oid', this.addForm.id)
      param.append('name', this.addForm.fileName)
      param.append('file', this.addForm.picJdcmp2)
      this.$formData('/file/upload', param).then(
        result => {
          if (result.status === 200) {
            this.picJdcmp2 = { src: '', file: '', name: '文件' }
            this.addForm.fileName = ''
            this.addForm.picJdcmp2 = ''
            this.queryFile()
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 删除文件
    delFile(data) {
      const param = {
        id: data.id
      }
      this.$root.$children[0].vueConfirm({ message: '确定要删除文件？', type: 'warning' }, () => {
        this.$get('/file/delete', param).then(
          result => {
            if (result.status === 200) {
              this.queryFile()
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      })
    },
    // 上传图片
    uploadPic() {
      const param = new FormData()
      if (!this.addForm.picName) {
        return this.$root.$children[0].vueAlert({ message: '请填写图片名称', type: 'error' })
      }
      if (!this.addForm.picJdcmp) {
        return this.$root.$children[0].vueAlert({ message: '请选择图片', type: 'error' })
      }
      param.append('oid', this.addForm.id)
      param.append('name', this.addForm.picName)
      param.append('pic', this.addForm.picJdcmp)
      this.$formData('/pic/upload', param).then(
        result => {
          if (result.status === 200) {
            this.picJdcmp = { src: '', file: '', name: '图片' }
            this.addForm.picName = ''
            this.addForm.picJdcmp = ''
            this.queryPic()
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 删除图片
    delPic(data) {
      console.log(data)
      const param = {
        id: data.id
      }
      this.$root.$children[0].vueConfirm({ message: '确定要删除图片？', type: 'warning' }, () => {
        this.$get('/pic/delete', param).then(
          result => {
            if (result.status === 200) {
              this.queryPic()
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      })
    },
    downloadIamge(imgsrc, name) {
      if (window.location.host !== 'wechat.suzhougs.com') {
        imgsrc = '/imgProxy/' + imgsrc
      }
      // 下载图片地址和图片名
      const image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function() {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        const url = canvas.toDataURL('image/jpeg') // 得到图片的base64编码数据
        const a = document.createElement('a') // 生成一个a元素
        const event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    // 图片选择
    picSelectionChange(val) {
      this.picSelection = val
      console.log(this.picSelection)
    },
    // 图片选择下载
    picSelectionDownload() {
      if (this.picSelection.length <= 0) {
        return this.$root.$children[0].vueAlert({ message: '请选择图片', type: 'error' })
      }
      for (let i = 0; i < this.picSelection.length; i++) {
        this.downloadIamge(this.picSelection[i].url, '图片-' + this.picSelection[i].name)
      }
    },
    // 图片选择
    fileSelectionChange(val) {
      this.fileSelection = val
      console.log(this.fileSelection)
    },
    // 图片选择下载
    fileSelectionDownload() {
      if (this.fileSelection.length <= 0) {
        return this.$root.$children[0].vueAlert({ message: '请选择文件', type: 'error' })
      }
      for (let i = 0; i < this.fileSelection.length; i++) {
        this.downloadIamge(this.fileSelection[i].url, '文件-' + this.fileSelection[i].name)
      }
    },
    // 新增保存
    addSave(name) {
      console.log(this.$common.jsonStr(this.addForm))
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log('通过')
          const fees = []
          for (let i = 0; i < this.fees.length; i++) {
            fees.push({
              customerName: this.addForm.name,
              name: this.fees[i].name,
              price: this.fees[i].price,
              payType: this.fees[i].payType,
              payPeriodStart: this.fees[i].payPeriodStart,
              payPeriodEnd: this.fees[i].payPeriodEnd
            })
          }
          const param = {
            name: this.addForm.name, // 公司名称
            simpleName: this.addForm.simpleName, // 公司简称
            area1: this.addForm.area1,
            area2: this.addForm.area2,
            area3: this.addForm.area3,
            address: this.addForm.address, // 地址
            legalPerson: this.addForm.legalPerson, // 法人
            taxNature: this.addForm.taxNature, // 纳税性质
            payType: this.addForm.payType, // 计费周期
            payPeriodStart: this.addForm.payTime[0]
              ? this.$common.timeFormat(new Date(this.addForm.payTime[0]), 'yyyy-MM-dd 00:00:00')
              : '',
            payPeriodEnd: this.addForm.payTime[1]
              ? this.$common.timeFormat(new Date(this.addForm.payTime[1]), 'yyyy-MM-dd 00:00:00')
              : '',
            accountManagerId: this.addForm.accountManagerId, // 客户经理
            accountManager: this.addForm.accountManager, // 客户经理
            accountant: this.accountants, // 负责人
            remark: this.addForm.remark, // 备注
            contacts: this.contacts, // 客户联系人数组
            fee: fees // 收费项目数组
          }
          this.$post('/customer/add', param).then(
            result => {
              if (result.status === 200) {
                this.web = 'main'
                this.titles = ['客户中心']
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                this.$emit('save')
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑保存
    editSave(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log('通过')
          const param = {
            id: this.addForm.id,
            name: this.addForm.name, // 公司名称
            simpleName: this.addForm.simpleName, // 公司简称
            area1: this.addForm.area1,
            area2: this.addForm.area2,
            area3: this.addForm.area3,
            address: this.addForm.address, // 地址
            legalPerson: this.addForm.legalPerson, // 法人
            taxNature: this.addForm.taxNature, // 纳税性质
            payType: this.addForm.payType, // 计费周期
            payPeriodStart: this.addForm.payTime[0]
              ? this.$common.timeFormat(new Date(this.addForm.payTime[0]), 'yyyy-MM-dd 00:00:00')
              : '',
            payPeriodEnd: this.addForm.payTime[1]
              ? this.$common.timeFormat(new Date(this.addForm.payTime[1]), 'yyyy-MM-dd 00:00:00')
              : '',
            accountManagerId: this.addForm.accountManagerId, // 客户经理
            accountManager: this.addForm.accountManager, // 客户经理
            remark: this.addForm.remark // 备注
          }
          this.$post('/customer/update', param).then(
            result => {
              if (result.status === 200) {
                this.web = 'main'
                this.titles = ['客户中心']
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                this.$emit('save')
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 返回列表
    cancel(state) {
      if (state === 'detail') {
        if (this.addForm.id) {
          this.titles = ['客户中心', '编辑客户']
          this.web = 'edit'
        } else {
          this.titles = ['客户中心', '新增客户']
          this.web = 'add'
        }
      } else {
        this.addForm = {}
        this.web = 'main'
        this.titles = ['客户中心']
        this.picJdcmp = { src: '', file: '', name: '图片' }
        this.picJdcmp2 = { src: '', file: '', name: '文件' }
        this.$refs.addForm.resetFields()
        this.$emit('cancel')
      }
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    }
    this.web = this.webState
    this.persons = this.detailPersons
    this.addForm = this.detailData
    this.queryCode(1)
    this.queryCode(2)
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.user {
  padding: 2vh 2vw 0;
  .title {
    height: 3vh;
    line-height: 3vh;
    font-size: 1.5rem;
    margin-bottom: 1.4vh;
  }
}
.edit-page,
.main-page {
  height: 100%;
}
.img-box {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 10vh;
    min-height: 10vh;
  }
  .upload {
    display: inline-flex;
    position: relative;
    align-items: center;
    justify-content: center;
    vertical-align: text-bottom;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
  .mask {
    display: flex;
    position: relative;
    width: 10vh;
    height: 10vh;
    color: #ccc;
    background: rgba(0, 0, 0, 0.5);
    font-size: 2.15rem;
    line-height: 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .mask-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
      z-index: 1000;
    }
    .el-icon-plus {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
    .text {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
  }
}
.drawer-box {
  max-height: 100vh;
  overflow: auto;
  padding: 0 8px;
}
</style>
